/* @jsx h */
import { defineComponent, h } from "vue";
import { LoyaltyCoinProgramsPage } from "../../../../ManagerPromotions/subpages/CoinPrograms";
import { useGroupAuth } from "@app/vue/providers/GroupAuth";

export const GroupCoinProgramsPage = defineComponent({
  name: "GroupCoinProgramsPage",
  setup() {
    const auth = useGroupAuth();
    return () => (
      <LoyaltyCoinProgramsPage
        scope="group"
        canManage={auth.isGroupAdmin.value}
      />
    );
  },
});
